
<mat-tab-group>
<mat-tab label="New Payment" class="tab_btn default_secondary-btn">
<mat-tab-group style="justify-content: flex-end;">
    <mat-tab [label]="paymentname.firstName" (click)="selectPaymentType('Incident')" >
        <cradua-bulkandsurfaceright
[lessors]="lessors$ | async"
[ownershiptypes]="ownershiptypes"
[lossofuseitems]="lossofuseitems$ | async"
[PaymentType]="PaymentType"
[quantums]="quantums"
[LandTitleSerialNo]="LandTitleSerialNo"
[terrains]="terrains"
[addressbooks]="addressbooks"
[lessorInfos]="lessorInfos"
[lessorRepresentatives]="lessorRepresentatives"
[lessorStakeholders]="lessorStakeholders"
[banks]="banks"
[measures]="uoms"
[lessorRepTypes]="lessorRepTypes"
[individualAcreages]="individualAcreages"
(submitevent)="onSubmit($event)"
(deleteEvent)="deletePayment($event)"
(addressssearchevent)="searchAddressBook($event)"
></cradua-bulkandsurfaceright>
    </mat-tab>
    <mat-tab [label]="paymentname.secondName">
<cradua-enumeratedandagreage
[lessors]="lessors$ | async"
[LandTitleSerialNo]="LandTitleSerialNo"
[quantums]="quantums"
[lessorInfos]="lessorInfos"
[lessorRepresentatives]="lessorRepresentatives"
[lessorStakeholders]="lessorStakeholders"
[banks]="banks"
[ownershiptypes]="ownershiptypes"
[terrains]="terrains"
[itemList]="itemList$ | async"
[PaymentType]="PaymentType"
[measures]="uoms"
[addressbooks]="addressbooks"
[lessorRepTypes]="lessorRepTypes"
[individualAcreages]="individualAcreages"
(searchEvent)="searchItem($event)"
(addressssearchevent)="searchAddressBook($event)"
(deleteEvent)="deletePayment($event)"
(submitevent)="onSubmit($event)"
></cradua-enumeratedandagreage>
    </mat-tab>

    <mat-tab [label]="'Approval'">
      <cradua-payment-approval
      [lessors]="lessors$ | async"
      [addressbooks]="addressbooks"
      [LandTitleSerialNo]="LandTitleSerialNo"
      [batches]="batches$ | async"
      (addressssearchevent)="searchAddressBook($event)"
      (deletelessorevent)="deletePayment($event)"
      (submitevent)="onSubmit($event)"
      ></cradua-payment-approval>
          </mat-tab>
</mat-tab-group>





</mat-tab>
<mat-tab label="Payment details" class="tab_btn default_secondary-btn">
<cradua-payment
[lessors]="lessors$ | async"
[addressbooks]="addressbooks"
[LandTitleSerialNo]="LandTitleSerialNo"
(addressssearchevent)="searchAddressBook($event)"
(deletelessorevent)="deletePayment($event)"
></cradua-payment>
</mat-tab>
<mat-tab label="Payment processing">
<cradua-payment-processing
[lessors]="lessors$ | async"
[addressbooks]="addressbooks"
[LandTitleSerialNo]="LandTitleSerialNo"
[batches]="batches$ | async"
(addressssearchevent)="searchAddressBook($event)"
(deletelessorevent)="deletePayment($event)"
(submitevent)="onSubmit($event)"
></cradua-payment-processing>

</mat-tab>
</mat-tab-group>
